import {
    useQuery
} from 'react-query';


export function useListThemes(useQueryOptions) {
    const accountId = RivalIQ.state.account.get('id');
    return useQuery(['accountThemes'], async () => {
        const configuration = await $.getJSON(`/api/account/${accountId}/listeningThemes`);
        return configuration;
    }, {
        ...useQueryOptions,
        staleTime: Infinity
    });
}

export function useListTopics(useQueryOptions) {
    const accountId = RivalIQ.state.account.get('id');
    return useQuery(['accountTopics'], async () => {
        const configuration = await $.getJSON(`/api/account/${accountId}/listeningTopics`);
        return configuration;
    }, {
        ...useQueryOptions,
        staleTime: Infinity
    });
}
